import { IInvestorFavorite } from '../models/dashboardModels';

export const getNamedFavorites = (
  favorites: IInvestorFavorite[] = [],
): IInvestorFavorite[] =>
  favorites.filter((favorite) => favorite.project_name || favorite.property_name);

export const getFavoritesSummaryLabel = (
  favorites: IInvestorFavorite[] = [],
): string => {
  const namedFavorites = getNamedFavorites(favorites);
  const projectsCount = namedFavorites.filter(
    (favorite) => favorite.project_name,
  ).length;
  const propertiesCount = namedFavorites.filter(
    (favorite) => favorite.property_name,
  ).length;

  const parts: string[] = [];
  if (projectsCount > 0) {
    parts.push(`${projectsCount} proyecto${projectsCount > 1 ? 's' : ''}`);
  }
  if (propertiesCount > 0) {
    parts.push(`${propertiesCount} propiedad${propertiesCount > 1 ? 'es' : ''}`);
  }

  return `${parts.join(' y ')} en favoritos`;
};
